<script>

export default {
  props: ['user'],
  data() {
    return {
      user:{}
    }
  },
  created() {
    let userStr = sessionStorage.getItem("user") || "{}"
    this.user = JSON.parse(userStr)
  },
  methods:{

    exit(){
      this.$router.push("/login")
      this.$message.success("退出成功")
    },
    info(){
      this.$router.push("/person")
    }
  }
}

</script>

<template>
  <div style="height: 50px;line-height: 50px;border-bottom:1px solid #ccc ;display: flex">
    <div style="width:200px;padding-left: 30px;font-weight: bold;color: dodgerblue">后台管理</div>
    <div style="flex: 1"></div>
    <div style="width: 100px;padding-top: 10px;padding-right: 10px"><!--- el-dropdown是添加的组件 --->
      <el-dropdown>
        <el-button type="primary">
          {{ user?.nickName }}<el-icon class="el-icon--right"></el-icon>
        </el-button>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click="info">个人信息</el-dropdown-item>
            <el-dropdown-item @click="exit">退出系统</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<style scoped>

</style>